import { css } from 'styled-components';

import { iconElementsSelector } from 'components/elements/styles/icon';

import { Colors } from './ui';

export const publicFocusRing = (color: string): string => `
  &:focus-visible {
    outline: 0.2rem solid ${color};
    outline-offset: 0.2rem;

    @media (forced-colors: active) {
      outline-color: Highlight;
    }
  }
`;

type MenuActiveItemIconProps = {
  skipIcon?: boolean;
  active: boolean;
};

type MenuActiveText = {
  active: boolean;
};

type ThemedButtonProps = {
  textColor: string;
  backgroundColor: string;
  borderColor: string;
};

export const menuActiveItemIcon = ({
  skipIcon,
  active,
}: MenuActiveItemIconProps) =>
  !skipIcon &&
  active &&
  css`
    ${iconElementsSelector} {
      stroke: ${Colors.tealDark};
    }
  `;

export const menuActiveText = ({ active }: MenuActiveText) =>
  active &&
  css`
    font-weight: 500;
    color: ${Colors.tealDark};
  `;

export const menuItemMixin = () =>
  css`
    ${menuActiveText}
    ${menuActiveItemIcon}

    &:hover {
      background-color: ${Colors.tealLightest};
    }
  `;

export const themedButtonMixin = ({
  textColor,
  backgroundColor,
  borderColor,
}: ThemedButtonProps) => css`
  color: ${textColor};

  &,
  &:hover,
  &:focus {
    background-color: ${backgroundColor};
    border-color: ${borderColor};
  }

  & ${iconElementsSelector} {
    stroke: ${textColor};
  }
`;

export const forcedColorsButtonBorder = `
  @media (forced-colors: active) {
    border: 1px solid ButtonText;
  }
`;

export const monospaceFont = `
  font-family: 'SF Mono', 'Fira Code', monospace;
`;

export const visuallyHiddenMixin = `
  position: absolute;
  width: 0.1rem;
  height: 0.1rem;
  padding: 0;
  margin: -0.1rem;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
